import React, { Component } from 'react'
import { object } from 'prop-types'

class Info extends Component {
  render () {
    const { data } = this.props

    return (
      <div className="billing-info">
        <table className="table">
          <tbody>
            <tr>
              <td><span className="info-label">LAST NAME:</span> <strong>{ data.get('last_name') }</strong></td>
              <td><span className="info-label">FIRST NAME:</span> <strong>{ data.get('first_name') }</strong></td>
              <td><span className="info-label">MIDDLE NAME:</span> <strong>{ data.get('middle_name') }</strong></td>
              <td><span className="info-label">EXT:</span> <strong>{ data.get('suffix_name') }</strong></td>
            </tr>
            <tr>
              <td><span className="info-label">STUDENT ID No:</span> <strong>{ data.get('student_id') }</strong></td>
              <td><span className="info-label">COURSE/MAJOR & YR.:</span> <strong>{ data.get('course_code') } - { data.get('level') }</strong></td>
              <td><span className="info-label">SCHOLARSHIP:</span> <strong>{ data.get('scholarship_code') }</strong></td>
              <td><span className="info-label">SEX:</span> <strong>{ data.get('sex') }</strong></td>
            </tr>
          </tbody>
        </table>
      </div>
    )
  }
}

Info.propTypes = {
  data: object,
}

export default Info



// WEBPACK FOOTER //
// ./src/containers/Print/Billing/info.js